// Read more content js
// Hide the extra content initially, using JS so that if JS is disabled, no problemo:

$(document).ready(function(){
  if($('.collection-hero__description p').length > 1){
    $('.collection-hero__description p').not(':first').addClass('hide');
    $('.collection-hero__description ol').addClass('hide');
    $('.collection-hero__description h2').addClass('hide');
    $('.collection-hero__description h3').addClass('hide');
    $('.collection-hero__description p:first').after('<a class="read-more-show">Read More...</a>');
    $('.collection-hero__description p:last-child').after(' <a class="read-more-hide hide">Read Less</a>');

    // Set up the toggle effect:
    $('.read-more-show').on('click', function(e) {
      e.preventDefault();
      $('.collection-hero__description p,.collection-hero__description ol, .collection-hero__description h2, .collection-hero__description h3').removeClass('hide');
      $(this).addClass('hide');
      $('.read-more-hide').removeClass('hide');
    });

    $('.read-more-hide').on('click', function(e) {
      $(this).parents('.collection-hero__description').find('p').not(':first').addClass('hide').parent().children('.read-more-show').removeClass('hide');
      $('.collection-hero__description ol').addClass('hide');
      $('.collection-hero__description h2').addClass('hide');
      $('.collection-hero__description h3').addClass('hide');
      $(this).addClass('hide');
      var element = document.querySelector(".collection-hero__description");

      // smooth scroll to element and align it at the bottom
      element.scrollIntoView({ behavior: 'smooth', block: 'end'});
    });
  }
  $('.collection-hero__description').removeClass('hide');   

  if($('.product__description  p').length > 1){
      $('.product__description p').not(':first').addClass('hide');
      $('.product__description p:first').after('<a class="show-more">Read More...</a>');
      $('.product__description p:last-child').after(' <a class="hide-more hide">Read Less</a>');

      // Set up the toggle effect:
      $('.show-more').on('click', function(e) {
        e.preventDefault();
        $('.product__description p').removeClass('hide');
        $(this).addClass('hide');
        $('.hide-more').removeClass('hide');
      });

      $('.hide-more').on('click', function(e) {
        $(this).parents('.product__description').find('p').not(':first').addClass('hide').parent().children('.show-more').removeClass('hide');
        $(this).addClass('hide');
        
        var element = document.querySelector(".product__description");

        // smooth scroll to element and align it at the bottom
        element.scrollIntoView({ behavior: 'smooth', block: 'center'});
      });
    } 
  $('.product__description').removeClass('hide'); 

  if($('.rich-text__text p').length > 1){
      $('.rich-text__text p').not(':first').addClass('hide');
      $('.rich-text__text p:first').after('<a class="show-more">Read More...</a>');
      $('.rich-text__text p:last-child').after('<a class="hide-more hide">Read Less</a>');

      // Set up the toggle effect:
      $('.show-more').on('click', function(e) {
        e.preventDefault();
        $('.rich-text__text p').removeClass('hide');
        $(this).addClass('hide');
        $('.hide-more').removeClass('hide');
      });

      $('.hide-more').on('click', function(e) {
        $(this).parents('.rich-text__text').find('p').not(':first').addClass('hide').parent().children('.show-more').removeClass('hide');
        $(this).addClass('hide');
        
        var element = document.querySelector(".rich-text__text");

        // smooth scroll to element and align it at the bottom
        element.scrollIntoView({ behavior: 'smooth', block: 'center'});
      });
    } 

  $('.rich-text__text').removeClass('hide'); 
  
});